import { DevelopmentalData } from "@/types/developmental";

export const age4Activities: DevelopmentalData = {
  motor: [
    "Jump rope games",
    "Ball sports",
    "Drawing activities",
    "Dance routines",
    "Obstacle courses"
  ],
  language: [
    "Letter recognition games",
    "Storytelling exercises",
    "Rhyming games",
    "Conversation practice",
    "Reading activities"
  ],
  cognitive: [
    "Counting games",
    "Pattern activities",
    "Science experiments",
    "Memory games",
    "Problem-solving tasks"
  ],
  independent: [
    "Chore assignments",
    "Self-care routines",
    "Time management games",
    "Decision-making activities",
    "Organization tasks"
  ],
  social: [
    "Team games",
    "Role-playing scenarios",
    "Conflict resolution practice",
    "Group projects",
    "Friendship activities"
  ]
};